import AddIcon from '@mui/icons-material/Add';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import SearchIcon from '@mui/icons-material/Search';
import {
  Tab, Tabs,
} from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { makeStyles } from '@mui/styles';
import { DataGrid, GridOverlay } from '@mui/x-data-grid';
import PropTypes from 'prop-types';
import React, { useReducer } from 'react';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import getSiteAttributes from '../../../api/oc_product/bulk/sites/site_attributes/gets/getSiteAttributes';
import deleteProductType from '../../../api/oc_product/productDataManagement/productTypes/delete/deleteProductType';
import getProductTypes from '../../../api/oc_product/productDataManagement/productTypes/get/getProductTypes';
import postProductTypeLogs from '../../../api/oc_product/productDataManagement/productTypes/post/postProductTypeLogs';
import Modal from '../../../components/Modal';
import CreateModal from './components/modals/CreateModal';
import EditModal from './components/modals/EditModal';
import { ProductTypeContext } from './ProductTypeContext';
import ProductTypeHeader from './ProductTypeHeader';
import ProductTypeLogs from './ProductTypeLogs';

function TabPanel({
  children,
  value,
  index,
  ...other
}) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

TabPanel.defaultProps = {
  children: {},
  index: 0,
  value: 0,
};

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number,
  value: PropTypes.number,
};
const reducer = (state, action) => {
  switch (action.type) {
    case 'ATTRIBUTE':
      return {
        ...state,
        attribute: action.payload,
      };
    default:
      return state;
  }
};
function CustomizedNoRowsOverlay(addNewProductTypeHandler) {
  return (
    <GridOverlay className="h-1/3">
      <Box display="flex" flexDirection="column" alignItems="center" justifyContent="flex" p={2}>
        <h1 className="text-2xl text-stone-500 font-gothambook">No results have been returned</h1>
        <h1 className="mt-1 mb-5 text-sm font-bold text-stone-700">Change search parameter or</h1>
        <Button
          variant="contained"
          color="primary"
          startIcon={<AddIcon />}
          sx={{
            borderRadius: '20px',
            width: 190,
            height: 40,
            backgroundColor: '#384451',
          }}
          onClick={addNewProductTypeHandler}
        >
          Product Type
        </Button>
      </Box>
    </GridOverlay>
  );
}
function ProductTypes() {
  const initialState = {
    attribute: null,
  };
  const [tabIndex, setTabIndex] = React.useState(0);
  const [tabValue, setTabValue] = React.useState(0);
  const [rows, setRows] = React.useState([]);
  const [originalRows, setOriginalRows] = React.useState([]);
  const [resetData, setResetData] = React.useState(false);
  const [searchValue, setSearchValue] = React.useState('');
  const [siteAttributeOptions, setSiteAttributeOptions] = React.useState([]);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [selectedAttribute, setSelectedAttribute] = React.useState([]);
  const [openModal, setOpenModal] = React.useState(false);
  const [deleteRow, setDeleteRow] = React.useState(null);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [itemsPerPage, setItemsPerPage] = React.useState(10);
  const [searchParams, setSearchParams] = useSearchParams();
  const [searchLable, setSearchLable] = React.useState('Name');
  const [openCreate, setOpenCreate] = React.useState(false);
  const [openEditModal, setOpenEditModal] = React.useState(false);
  const [selectedRowData, setSelectedRowData] = React.useState(null);
  const [productTypeCount, setProductTypeCount] = React.useState(0);
  // logs
  const [username, setUsername] = React.useState('');
  const [fromDate, setFromDate] = React.useState(null);
  const [toDate, setToDate] = React.useState(null);
  const pageSize = searchParams.get('pageSize');
  // const [totalRows, setTotalRows] = React.useState(0);
  const [logs, setLogs] = React.useState([]);
  const [logsTotalPages, setLogsTotalPages] = React.useState();
  const [logsPerPage, setLogsPerPage] = React.useState(10);
  const [logsTotalRows, setLogsTotalRows] = React.useState(0);
  const tabs = ['Product Types', 'Logs'];
  const [logcurrentPage, setLogCurrentPage] = React.useState(1);
  const [name, setName] = React.useState('');
  const siteId = useSelector(
    (state) => state.user.loginResponse?.selectedSite?.SiteId,
  );
  const siteCode = useSelector((state) => state.user.loginResponse?.selectedSite?.SiteCode);

  const languageId = useSelector((state) => state.user.loginResponse?.selectedSite?.LanguageId);
  const [state, dispatch] = useReducer(reducer, initialState);
  const open = Boolean(anchorEl);
  const fetchLogs = async () => {
    const logsData = await postProductTypeLogs(
      siteId,
      currentPage,
      logsPerPage,
      searchValue,
      fromDate,
      toDate,
    );
    setLogs(logsData.data.Data);
    setLogsTotalPages(logsData.data.Pagination.PageCount);
    setLogsTotalRows(logsData.data.Summary.TotalRowCount);
  };
  const fetchData = async () => {
    try {
      const [response1, response2, response3] = await Promise.all([
        getSiteAttributes(siteId, 2, languageId),
        getSiteAttributes(siteId, 3, languageId),
        getSiteAttributes(siteId, 1, languageId),
      ]);
      const productTypeAttributes = [
        ...response1.data,
        ...response2.data,
        ...response3.data,
      ];

      const attributeId = state.attribute || 0;
      const productTypesData = await getProductTypes(siteId);
      setProductTypeCount(productTypesData.data.length);
      const mappedRows = productTypesData.data.map((item, index) => ({
        id: index + 1,
        name: item.ProductTypeName,
        departmentCode: item.DepartmentCode,
        default: item.IsDefault,
        dateCreated: item.Created,
        productTypeId: item.ProductTypeId,
        attributeName: productTypeAttributes.find((attr) => attr.ProductAttributeDefId === attributeId)?.AttributeName || '',
      }));
      setRows(mappedRows);
      setOriginalRows(mappedRows);
      fetchLogs();
    } catch (error) {
      console.error('Error fetching product types data:', error);
    }
  };

  const resetAllFilters = () => {
    setSearchValue('');
  };
  const addNewProductTypeHandler = async () => {
    setOpenCreate(true);
  };
  const contextValue = React.useMemo(() => (
    {
      siteId,
      name,
      setName,
      tabIndex,
      setTabIndex,
      username,
      setUsername,
      fromDate,
      setFromDate,
      toDate,
      setToDate,
      resetAllFilters,
      fetchData,
      fetchLogs,
      setAnchorEl,
      anchorEl,
      open,
      selectedAttribute,
      setSelectedAttribute,
      searchValue,
      setSearchValue,
      searchLable,
      setSearchLable,
      siteCode,
      siteAttributeOptions,
      setSiteAttributeOptions,
      setLoading,
      loading,
      openCreate,
      setOpenCreate,
      setRows,
      initialState,
      productTypeCount,
      addNewProductTypeHandler,
    }
  ), [siteId, name, setName, tabIndex, setTabIndex, username,
    setUsername,
    fromDate,
    setFromDate,
    toDate,
    setToDate,
    resetAllFilters,
    fetchData,
    fetchLogs,
    setAnchorEl,
    anchorEl,
    open,
    selectedAttribute,
    setSelectedAttribute,
    searchValue,
    setSearchValue,
    searchLable,
    setSearchLable,
    siteCode,
    siteAttributeOptions,
    setSiteAttributeOptions,
    setLoading,
    loading,
    openCreate,
    setOpenCreate,
    setRows,
    initialState,
    productTypeCount,
    addNewProductTypeHandler]);

  const handleTabChange = (event, newValue) => {
    setRows([]);
    setCurrentPage(1);
    setItemsPerPage(15);
    setLogsTotalPages(0);
    setLogsTotalRows(0);
    setLogCurrentPage(1);
    setTabValue(newValue);
    setTabIndex(newValue);
    setSearchValue('');
    if (newValue === 1) {
      setSearchLable('Logs');
      fetchLogs();
    }
    if (newValue === 0) {
      setSearchLable('Name');
    }
  };

  const useStyles = makeStyles({
    indicator: {
      backgroundColor: '#199fb1 !important', // secondary color
      height: '4px !important',
    },
    selected: {
      color: '#fff !important',
      opacity: '1 !important',
    },
    tabRoot: {
      color: '#fff !important',
      width: '50%',
    },
    table: {
      '& .MuiTableCell-root': {
        paddingTop: '6px',
        paddingBottom: '6px',
      },
    },
    cell: {
      borderRight: '1px solid rgba(224, 224, 224, 1)',
      '&:last-child': {
        borderRight: 'none',
      },
      '&.MuiTableCell-head': {
        backgroundColor: '#fafafa', // grey[100]
      },
      width: '50%',
      '&:first-child': {
        width: '50%',
      },
    },
  });
  const styles = useStyles();

  function a11yProps(index) {
    return {
      id: `scrollable-auto-tab-${index}`,
      'aria-controls': `scrollable-auto-tabpanel-${index}`,
    };
  }

  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const handleChangeItemsPerPage = (event) => {
    const newItemsPerPage = event.target.value;
    const newPageCount = Math.ceil(logsTotalRows / newItemsPerPage);
    const newPage = Math.min(currentPage, newPageCount);
    setLogsPerPage(newItemsPerPage);
    setCurrentPage(newPage);
  };
  const handleFilterReset = () => {
    setUsername('');
    setFromDate(null);
    setToDate(null);
    setResetData(true);
  };
  const fetchSiteAttributeOptions = async () => {
    try {
      const [response1, response2, response3] = await Promise.all([
        getSiteAttributes(siteId, 2, languageId),
        getSiteAttributes(siteId, 3, languageId),
        getSiteAttributes(siteId, 1, languageId),
      ]);
      const attributeOptions = [
        ...response1.data,
        ...response2.data,
        ...response3.data,
      ];

      setSiteAttributeOptions(attributeOptions);
    } catch (error) {
      console.error('Error fetching site attribute options:', error);
    }
  };

  const handleEditModalClose = () => {
    setOpenEditModal(false);
  };
  const handleUpdateSelectedRowData = async (updatedData) => {
    const rowIndex = rows.findIndex((row) => row.productTypeId === updatedData.productTypeId);
    if (rowIndex !== -1) {
      // Create a new array with the updated row
      const updatedRows = [...rows];
      updatedRows[rowIndex] = updatedData;

      setRows(updatedRows);
      setSelectedRowData(updatedData);
    }
  };
  const handleModalClose = () => {
    setOpenModal(false);
  };
  const handleDeleteProductType = async () => {
    try {
      await deleteProductType(siteId, deleteRow?.productTypeId);

      setRows((prevRows) => prevRows.filter((row) => row.id !== deleteRow?.id));
      setOriginalRows((prevOriginalRows) => prevOriginalRows.filter((row) => row.id !== deleteRow?.id));

      toast.success(`${deleteRow?.departmentCode === null ? '' : deleteRow?.departmentCode}
        of Product Type ${deleteRow?.name} successfully deleted`);
      fetchLogs();
      fetchData();
    } catch (error) {
      console.error(error);
      toast.error('Failed to delete product type');
    } finally {
      setOpenModal(false);
    }
  };

  // useEffects

  React.useEffect(() => {
    setSearchParams((params) => {
      const arr = [];
      // eslint-disable-next-line no-restricted-syntax
      for (const key of params.keys()) {
        arr.push(key);
      }
      /**
     * For some reason we have to do this...
     * If you do the, if not then delete, statement below within the for above
     * or do params.forEach
     * The loop with miss every even indexed key...
     */
      arr.forEach((key) => {
        if (key !== 'siteCode' && key !== 'page' && key !== 'omsId' && key !== 'pageSize') {
          params.delete(key);
        }
      });
      return params;
    });
  }, []);
  React.useEffect(() => {
    fetchLogs();
  }, [currentPage, itemsPerPage, siteId]);
  React.useEffect(() => {
    fetchLogs();
  }, [tabIndex]);
  React.useEffect(() => {
    if (searchValue !== '') {
      const filteredRows = originalRows.filter((row) => (row.name.toLowerCase().includes(searchValue.toLowerCase())));
      setRows(filteredRows);
    } else {
      setRows(originalRows);
    }
  }, [originalRows]);
  React.useEffect(() => {
    const fetchDataAndAttributes = async () => {
      try {
        if (searchValue.length > 0) {
          setSearchValue('');
        }
        await fetchData(siteId);
        dispatch({ type: 'RESET', payload: initialState });
        fetchSiteAttributeOptions();
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchDataAndAttributes();
  }, [tabIndex, siteId]);

  React.useEffect(() => {
    if (resetData) {
      fetchLogs();
    }
  }, [resetData]);
  const columns = [
    {
      field: 'name',
      headerName: 'Name',
      width: 300,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'departmentCode',
      headerName: 'Department Code',
      width: 300,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'isDefault',
      headerName: 'Default',
      width: 300,
      headerAlign: 'center',
      align: 'center',
      renderCell: (params) => (
        params.row.default === true ? (
          <CheckCircleIcon className="text-success-600" />
        ) : (
          <CancelIcon className="text-error-600" />
        )
      ),
    },
    {
      field: 'dateCreated',
      headerName: 'Date Created',
      width: 300,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'actions',
      headerName: 'Search',
      width: 300,
      headerAlign: 'center',
      align: 'center',
      renderCell: (row) => (
        <Stack direction="row" spacing={2} justifyContent="center" alignItems="center">
          <SearchIcon
            onClick={() => {
              const { productTypeId } = row.row;
              const url = `/product-info/products?pageSize=15&page=1&productTypes=${productTypeId}`;
              window.open(url, '_blank');
            }}
          />
        </Stack>
      ),
    },
    {
      field: 'delete',
      headerName: 'Delete',
      width: 300,
      headerAlign: 'center',
      align: 'center',
      renderCell: (params) => (
        <Stack direction="row" spacing={2} justifyContent="center" alignItems="center">
          <DeleteForeverIcon
            sx={{
              cursor: 'pointer',
              opacity: '0.5',
              '&:hover': {
                color: 'red',
              },
            }}
            onClick={(event) => {
              event.stopPropagation();
              setOpenModal(true);
              setDeleteRow(params.row);
            }}
          />
        </Stack>
      ),
    },
  ];

  return (
    <ProductTypeContext.Provider value={contextValue}>
      <div className="pt-4 md:p-8">
        <Box
          sx={{
            paddingLeft: '16px',
            paddingRight: '16px',
          }}
        >
          {/* Modals */}
          <CreateModal
            open={openCreate}
            onClose={setOpenCreate}
            fetchData={fetchData}
          />
          <EditModal
            open={openEditModal}
            onClose={handleEditModalClose}
            selectedRowData={selectedRowData}
            selectedAttribute={selectedAttribute}
            updatedSelectedRowData={handleUpdateSelectedRowData}
          />
          <Modal
            title="Delete Product Type"
            open={openModal}
            onClose={handleModalClose}
            buttonLabel="Confirm"
            buttonOnClick={handleDeleteProductType}
          >
            <Typography className="text-center">
              {`Are you sure you want to delete ${deleteRow?.departmentCode === null ? 'N/A' : deleteRow?.departmentCode}
                       of ${deleteRow?.name}`}
            </Typography>
          </Modal>
          {' '}
          <ProductTypeHeader tabIndex={tabIndex} />
        </Box>
        <Box sx={{
          px: 2, width: '100%', ml: 2,
        }}
        >
          <div style={{ marginTop: '-25px', marginLeft: '1px', marginRight: '1px' }}>

            <Tabs
              value={tabValue}
              onChange={handleTabChange}
              classes={{
                indicator: styles.indicator,
                root: styles.selected,
              }}
              variant="scrollable"
              scrollButtons="auto"
              allowScrollButtonsMobile
              className="flex flex-row"
              sx={{
                borderTopLeftRadius: '16px',
                borderTopRightRadius: '16px',
                overflow: 'hidden',
                position: 'sticky',
                top: 0,
                zIndex: 1000,
                backgroundColor: '#384451',
                px: 2,
              }}
            >
              {tabs.map((tab) => (
                <Tab
                  {...a11yProps(tabValue)}
                  key={tab}
                  label={tab}
                  classes={{
                    root: styles.tabRoot,
                    selected: styles.selected,
                  }}
                  sx={{ maxWidth: 'none' }}
                />
              ))}
            </Tabs>
            <TabPanel value={tabValue} index={0}>
              <Box sx={{ height: 'calc(100vh - 150px)' }}>
                <DataGrid
                  rows={rows}
                  columns={columns}
                  pageSize={pageSize}
                  rowsPerPageOptions={[15, 30, 50, 100]}
                  onCellClick={(params, event) => {
                    event.stopPropagation();
                    setOpenEditModal(true);
                    setSelectedRowData({
                      ...params.row,
                    });
                  }}
                  className="bg-white"
                  sx={{
                    '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': { py: '8px' },
                    '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': { py: '15px' },
                    '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': { py: '22px' },
                  }}
                  slots={{
                    noRowsOverlay: (() => CustomizedNoRowsOverlay(addNewProductTypeHandler)),
                  }}
                />
              </Box>
            </TabPanel>

            <TabPanel value={tabValue} index={1}>
              <ProductTypeLogs
                handleChangePage={handleChangePage}
                handleChangeItemsPerPage={handleChangeItemsPerPage}
                handleFilterReset={handleFilterReset}
                logs={logs}
                count={logsTotalPages}
                page={logcurrentPage}
                logsPerPage={logsPerPage}
              />
            </TabPanel>
          </div>

        </Box>
      </div>
    </ProductTypeContext.Provider>
  );
}

export default ProductTypes;
